import { Dispatch, SetStateAction, createContext } from "react";

export type DrillDownContextProps = {
  index?: number;
  setIndex?: (index: number | undefined) => void;
  back?: () => void;
  next?: () => void;
  registeredIndices?: number[];
  setRegisteredIndices?: Dispatch<SetStateAction<number[] | undefined>>;
  onClose?: (() => void)[];
  setOnClose?: (fn: () => void, index: number) => void;
  hostIsInteractive?: boolean;
  setHostTrigger?: (element: HTMLElement | null) => void;
  onHostClose?: () => void;
  onHostClosed?: () => void;
};

export const DrillDownContext = createContext<DrillDownContextProps | null>(
  null,
);
